import { ShareOfAccountsApi } from './factoryApi';
const instance = ShareOfAccountsApi()


const getAdminMessage = async () => {
	const response = await instance.get('api/anonymous/admin-message');
	return response.data;
}

const getCompetitors = async () => {
	const response = await instance.get('api/competitors');
	return response.data.Competitors;
};

const getShareOfAccounts = async (dealerId, quarter, year) => {
	const response = await instance.get('api/shareofaccounts', {
		params: {
			DealerAccountID: dealerId,
			Quarter: quarter,
			Year: year 
		},
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json' 
		}
	});
	return response.data;
}

const getUserInfo = async (userId) => {
	const response = await instance.get('api/user', {
		params: {
			DealerPortalID: userId
		},
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json' 
		}
	});
	return response.data;
}

const save = async (quarter, year, dealerId, user, shares) => {
	var parameters = getSaveParameters(quarter, year, dealerId, user, shares);

	console.log("resulting params:");
	console.log(parameters);

	var response = await instance.post('api/save', parameters);
	return response;
};

const submit = async (quarter, year, dealerId, user, shares) => {
	var parameters = getSaveParameters(quarter, year, dealerId, user, shares);
	
	console.log("resulting params:");
	console.log(parameters);

	var response = await instance.post('api/submit', parameters);
	return response;
}

const approve = async (quarter, year, dealerId, user, shares) => {
	var parameters = getSaveParameters(quarter, year, dealerId, user, shares);
	
	console.log("resulting params:");
	console.log(parameters);

	var response = await instance.post('api/approve', parameters);
	return response;
}

const deny = async (quarter, year, dealerId, user, shares) => {
	var parameters = getSaveParameters(quarter, year, dealerId, user, shares);
	
	console.log("resulting params:");
	console.log(parameters);

	var response = await instance.post('api/deny', parameters);
	return response;
}

const anonymousApprove = async (userId, submittedDate) => {
	var response = await instance.post('api/anonymous/approve', {UserID: userId, SubmittedDate: submittedDate});
	return response;
}

const anonymousDeny = async (userId, submittedDate) => {
	var response = await instance.post('api/anonymous/deny', {UserID: userId, SubmittedDate: submittedDate});
	return response;
}

const getSaveParameters = (quarter, year, dealerId, user, shares) => {
	console.log('value in the api:');
	console.log(shares);

	return {
		Quarter: quarter,
		Year: year,
		DealerId: dealerId,
		UserID: user.ContactID,
		UserEmail: user.Email,
		CompetitorShares: shares
			.filter(x => x.selectedCompetitor.label !== '')
			.map(x => ({
				CompetitorID: x.selectedCompetitor.id,
				CompetitorName: x.selectedCompetitor.label,
				Percentage: x.percentage,
				IsOther: x.selectedCompetitor.isOther
		}))
	};
}


export default {
	getAdminMessage,
	getCompetitors,
	getShareOfAccounts,
	getUserInfo,
	save,
	submit,
	approve,
	deny,
	anonymousApprove,
	anonymousDeny
};